let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.__pwaInstallPrompt = e;
});

// Recupera l'evento se è stato catturato dallo script inline in index.html prima del caricamento dei moduli
const getPrompt = () => deferredPrompt || window.__pwaInstallPrompt || null;

// Rileva iOS
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

// Rileva se già installata come standalone
const isInStandaloneMode = () =>
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

export const showInstallPrompt = async () => {
    if (isInStandaloneMode()) {
        // App già installata
        return;
    }

    const prompt = getPrompt();
    if (prompt) {
        // Android / Chrome desktop: usa il prompt nativo
        prompt.prompt();
        const { outcome } = await prompt.userChoice;
        deferredPrompt = null;
        window.__pwaInstallPrompt = null;
        return outcome;
    }

    if (isIos()) {
        // iOS non supporta beforeinstallprompt: mostra istruzioni manuali
        const { default: Swal } = await import('sweetalert2');
        Swal.fire({
            title: 'Installa su iPhone / iPad',
            html: `
                <p>Per installare l'app sul tuo dispositivo:</p>
                <ol style="text-align:left">
                    <li>Tocca <strong>Condividi</strong> <span style="font-size:1.2em">&#x2B06;</span> in basso (Safari)</li>
                    <li>Scorri e tocca <strong>"Aggiungi a Home"</strong></li>
                    <li>Conferma con <strong>"Aggiungi"</strong></li>
                </ol>
            `,
            icon: 'info',
            confirmButtonText: 'Capito',
        });
        return;
    }

    // Chrome/Android: il prompt non è disponibile (già installata, rifiutata in precedenza, o criteri non soddisfatti)
    const { default: Swal } = await import('sweetalert2');
    Swal.fire({
        title: 'Installazione non disponibile',
        text: "Il browser non ha reso disponibile il prompt di installazione. Prova ad usare il menu del browser → 'Aggiungi a schermata Home'.",
        icon: 'warning',
        confirmButtonText: 'Ok',
    });
};

export const canInstall = () => {
    return !isInStandaloneMode() && (getPrompt() !== null || isIos());
};
